module.exports = __webpack_public_path__ + "static/media/991933.5f9307cb.png";